import {Component, input} from '@angular/core';
import {MatCardModule} from '@angular/material/card';
import {ProjectDTO} from '../../../project/dto/project';
import {DatePipe} from '@angular/common';
import {MatDividerModule} from '@angular/material/divider';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-explore-project-card',
  imports: [MatCardModule,
    DatePipe,
    MatButtonModule,
    MatDividerModule,
    MatIconModule, RouterLink],
  templateUrl: './explore-project-card.component.html',
  styleUrl: './explore-project-card.component.scss'
})
export class ExploreProjectCardComponent {
  readonly project = input.required<ProjectDTO>();
}
